import {deepCopy, handleError} from '.';

import request from '../api/request';
import {alertActions} from '../actions';

function createAction(name) {
  return {
    LOADING: `${name}_LOADING`,
    COMPLETE: `${name}_COMPLETE`,
  };
}

function tableActions(name) {
  return {
    PAGE_CHANGED: `${name}_PAGE_CHANGED`,
    SORT_CHANGED: `${name}_SORT_CHANGED`,
    ALL_CHECKED_CHANGED: `${name}_ALL_CHECKED_CHANGED`,
    ITEM_CHECKED_CHANGED: `${name}_ITEM_CHECKED_CHANGED`,
    FILTER_OPTION_CHANGED: `${name}_FILTER_OPTION_CHANGED`,
    SEARCH_STRING_CHANGED: `${name}_SEARCH_STRING_CHANGED`,
  };
}

function handleLoading(loadingState, {field, loading}) {
  const updateLoadingState = deepCopy(loadingState);
  updateLoadingState[field] = loading;
  return updateLoadingState;
}

function genericLoad({
  dispatch,
  field,
  includePortal = true,
  payloadModifier = data => data,
  stateField = undefined,
  title,
  type,
  url,
  useMAPI = false,
  signal,
}) {
  dispatch({
    type: type.LOADING,
    field,
    loading: true,
  });

  return request({
    includePortal,
    url,
    useMAPI,
    signal
  })
    .then(response => {
      const modifiedPayload = payloadModifier(response.data);

      dispatch({
        type: type.COMPLETE,
        field,
        payload: modifiedPayload,
        stateField,
      });

      return modifiedPayload;
    })
    .catch(error => {
      if (error.name === 'AbortError') {
        return;
      }

      dispatch({
        type: type.LOADING,
        field,

        loading: false,
      });
      handleError(`Unable to load ${title}`, error, dispatch);
    });
}

function genericPut({
  body,
  dispatch,
  field,
  hideSuccessToastr = false,
  includePortal = true,
  payloadModifier = data => data,
  stateField = undefined,
  title,
  successMessage = `The ${title} has been updated.`,
  type,
  url,
  useMAPI = false,
}) {
  dispatch({
    type: type.LOADING,
    field,
    loading: true,
  });

  return request({
    body,
    includePortal,
    method: 'PUT',
    url,
    useMAPI,
  })
    .then(response => {
      if (!hideSuccessToastr) {
        dispatch(alertActions.success(successMessage));
      }

      dispatch({
        type: type.COMPLETE,
        field,
        payload: payloadModifier(response.data),
        stateField,
      });

      return Promise.resolve();
    })
    .catch(error => {
      dispatch({
        type: type.LOADING,
        field,
        loading: false,
      });
      handleError(`Unable to update ${title}`, error, dispatch);
    });
}

function genericDelete({
  dispatch,
  field,
  title,
  type,
  url,
  useMAPI = false,
  successMessage = `The ${title} has been deleted.`,
}) {
  dispatch({
    type: type.LOADING,
    field,
    loading: true,
  });

  return request({
    method: 'DELETE',
    url,
    useMAPI,
  })
    .then(() => {
      dispatch(alertActions.success(successMessage));
      dispatch({type: type.COMPLETE, field});
    })
    .catch(error => {
      dispatch({
        type: type.LOADING,
        field,
        loading: false,
      });
      handleError(`Unable to delete ${title}`, error, dispatch);
    });
}

export {
  createAction,
  genericDelete,
  genericLoad,
  genericPut,
  handleLoading,
  tableActions,
};



// WEBPACK FOOTER //
// ./src/helpers/reduxHelpers.js